<template>
  <div :class="[`sidebar`, `sidebar--${currentRouteName}`]">
    <div class="group group--df-column">
      <ul 
        v-if="showSidebarNav" 
        
        class="sidebar__nav fs0">
        <li
          v-for="(item, index) in navItems"
          :key="index"
          @click="scrollToSection(item.section)"
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          :class="[
            `sidebar__nav--item`,
            activeSection === item.section ? `fw-bold sidebar__nav--item-active` : ``,
          ]"
        >
          {{ item.label }}
        </li>
      </ul>

      <div v-if="showSidebarProvider" class="sidebar__provider-info fs0">
        <div class="provider__avatar" :style="avatarBg" />

        <div v-if="provider" :class="[`provider`, `provider--${$route.name}`]">
          <span 
            v-if="provider.topMatch" 
            :style="{ 'background-color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="provider__pill">Top match</span>
          <h2 
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
            class="h2 provider__title">{{ provider.fullname || provider.full_name }}</h2>
          
          
          <span class="provider__description fw-bold c-mid">{{ provider.specialty || provider.provider_type }}</span>
          <span class="provider__description--mobile c-mid" v-html="mobileDescription" />

          <span
            v-if="providerDetails && providerDetails.patient_appointment_types && $route.name === `provider-schedule`"
            class="provider__availability">

            Available by
            <span v-if="hasAvailability(`video`)" class="icon icon--video" />
            <span v-if="hasAvailability(`phone`)" class="icon icon--phone" />
          </span>

          <div v-if="showSelectedSlot" class="selected-slot fs0">
            <span class="selected-slot__icon selected-slot__icon--appointment" />
            <span class="selected-slot__label">{{ selectedSlot.timeslot | appointmentDateTime }}</span>
          </div>

          <div v-if="showSelectedSlot" class="selected-appointment fs0">
            <span :class="[`selected-appointment__icon`, `selected-appointment__icon--${selectedAppointmentType}`]" />
            <span class="selected-appointment__label">{{ selectedAppointmentType }}</span>
          </div>
        </div>
      </div>

      <!-- <div v-if="showF2f" class="sidebar__f2f">
        <p class="c-accent">Want to speak with someone sooner?</p>
        <router-link class="c-accent" :to="{ name: `results`}">Schedule a telephone or video call instead.</router-link>
      </div> -->

      <div v-if="showRegistrationSuccess" class="sidebar__register-success" />

      <module-disclaimer v-if="showDisclaimer" class="disclaimer--sidebar fs0" />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// 3rd party
import moment from 'moment';

// Modules
import ModuleDisclaimer from 'components/Disclaimer';

export default {
  name: 'ui-sidebar',


  // Components
  components: {
    ModuleDisclaimer,
  },


  // Filters
  filters: {
    appointmentDateTime (date) {
      if ( !date ) return;

      return moment(date).format('dddd - MMMM D, YYYY h:mma');
    },
  },


  // Components
  // Data
  data() {
    return {
      navItems: [
        {
          section: 'counselors',
          label: 'Recommended counselors',
        },
        {
          section: 'approach',
          label: 'Our approach',
        },
        {
          section: 'thingsToKnow',
          label: 'Things to know',
        },
      ],
    };
  },


  // Computed
  computed: {
    ...mapGetters('sidebar', ['activeSection']),
    ...mapGetters('provider', ['provider', 'selectedSlot', 'providerDetails', 'selectedAppointmentType']),
    ...mapGetters('questions', ['f2fSelected']),
    ...mapGetters('app', ['org']),
  

    currentRouteName() {
      return this.$route.name;
    },

    showSidebarNav() {
      return this.$route.name === 'results';
    },

    showSidebarProvider() {
      return this.$route.name === 'provider-schedule' || this.$route.name === 'appointment' || this.$route.name === 'provider-query' || this.$route.name === 'register' && !this.f2fSelected;
    },

    showSelectedSlot() {
      return this.$route.name === 'appointment' || this.$route.name === 'register' && this.selectedSlot;
    },

    // showRegistrationSuccess() {
    //   return this.$route.name === 'register-success';
    // },

    showF2f() {
      return this.$route.name === 'face-2-face' || this.f2fSelected && this.$route.name !== 'register-success';
    },

    showDisclaimer() {
      return this.$route.name === 'results' || this.$route.name === 'provider-schedule';
    },

    avatarBg() {
      if ( !this.provider ) return;

      if ( this.provider.photo_url_absolute ) {
        return { backgroundImage: `url(${this.provider.photo_url_absolute})` };
      }

      return {};
      
    },

    mobileDescription() {
      if ( !this.selectedSlot ) return;

      let desc = `${moment(this.selectedSlot.timeslot).format('dddd, MMMM D - h:mma')}`;

      if ( this.selectedAppointmentType ) {
        desc +=  `<br> <span class="ttc">${this.selectedAppointmentType}</span> session`;
      }

      return desc;
    },
  },


  // Methods
  methods: {
    ...mapActions('sidebar', ['saveActiveSection']),

    scrollToSection(section) {
      const map = {
        counselors: () => this.$scrollTo('#counselors', 1000, { offset: -300, top: 0 }),
        approach: () => this.$scrollTo('#approach', 1000, { offset: -250, top: 0 }),
        thingsToKnow: () => this.$scrollTo('#things-to-know', 1000, { offset: -200, top: 0 }),
      };

      map[section]();
      this.saveActiveSection(section);
    },

    hasAvailability(type) {
      return this.providerDetails.patient_appointment_types.indexOf(type) !== -1;
    },
  },
  // Watchers


  // Lifecycles
  created() {
    this.saveActiveSection('counselors');
  },
  // Filters
};
</script>



// WEBPACK FOOTER //
// Sidebar.vue?3590932a